import { render, staticRenderFns } from "./AnnualLeaveTypeForm.vue?vue&type=template&id=0e870858&"
import script from "./AnnualLeaveTypeForm.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnualLeaveTypeForm.vue?vue&type=style&index=0&id=0e870858&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports